import $ from 'jquery';

const namespace = 'searchbox';

export default class SearchBox {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          field: '.search__input',
          trigger: '.js-search__trigger',
          content: '.js-search__content',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.$el = $(el);
    this.$content = $(this.options.selectors.content, this.$el);

    this.bind();
  }

  bind() {
    this.$el.on(
      `focus.${namespace}`,
      this.options.selectors.field,
      this.handleFocus.bind(this),
    );

    this.$el.on(
      `blur.${namespace}`,
      this.options.selectors.field,
      this.handleBlur.bind(this),
    );

    this.$el.on(
      `click.trigger.${namespace}`,
      this.options.selectors.trigger,
      this.handleTriggerClick.bind(this),
    );
  }

  handleFocus() {
    this.$el.addClass(this.options.classes.active);
  }

  handleBlur() {
    this.$el.removeClass(this.options.classes.active);
  }

  handleTriggerClick(event) {
    event.preventDefault();
    this.$content.toggleClass(this.options.classes.active);
  }
}
